import AskAQuestion from "./AskAQuestion";

export default AskAQuestion;
